export interface HomeScope {
  readonly area?: string | undefined
  readonly initiative?: string | undefined
}

export function validateHomeScope(raw: Record<string, unknown>): HomeScope {
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return {
    area: typeof raw.area === 'string' && uuid.test(raw.area) ? raw.area : undefined,
    initiative:
      typeof raw.initiative === 'string' && uuid.test(raw.initiative)
        ? raw.initiative
        : undefined,
  }
}
